import React, { useEffect, useMemo, useState } from 'react'
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import { Box, MenuItem, TextField } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import IconButton from '@material-ui/core/IconButton'
import { userHasPermission } from 'helpers'
import { clearDashboard, fetchJobsSuccess, setCompanies, setCurrentCompany } from 'Store/modules/dashboard/actions'
import { connect } from 'react-redux'
import Popover from '@material-ui/core/Popover'
import { useAuth } from 'Contexts/AuthProvider'
import { Redirect } from 'react-router'
import dmsApiService from 'Services/DMS/dms-api.service'
import { setDepartments, setEmployees, setCurrentDepartment } from 'Store/modules/mms/actions'
import useTranslation from 'Hooks/useTranslation'
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined'
import WorkOutlineIcon from '@material-ui/icons/WorkOutline'
import BlurLinearOutlinedIcon from '@material-ui/icons/BlurLinearOutlined'
import MyLocationOutlinedIcon from '@material-ui/icons/MyLocationOutlined'
import MapOutlinedIcon from '@material-ui/icons/MapOutlined'
import DomainOutlinedIcon from '@material-ui/icons/DomainOutlined'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'
import StorageOutlinedIcon from '@material-ui/icons/StorageOutlined'
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined'
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined'
import { SlideMenu, SlideMenuSection, SlideMenuSubItem } from 'Components/SlideMenu/SlideMenu'
import 'moment/min/locales'
import moment from 'moment'
import 'react-circular-progressbar/dist/styles.css'
import AlertToastr from '../../utils/alert'
import { getStoredCompany, setStoredCompany } from '../../storage/company-storage'
import UserAvatar from '../UserAvatar'
import { appName } from 'config'
import useFooterSubscriptionPackage from 'Hooks/useFooterSubscriptionPackage'
import { setStoredDepartment } from '../../storage/department-storage'
import MyIcons from 'assets/img/Icons/MyIcons'
import DeleteItemModal from 'Components/modals/delete-item-modal/delete-item-modal.component'
import EventEmitter from '../../utils/EventEmitter'
import { Autocomplete } from '@material-ui/lab'
import Tooltip from '@material-ui/core/Tooltip'

const UserIcon = ({ name = 'John Doe' }) => <UserAvatar name={name}/>
const Header = ({
                  clearDashboard,
                  departments,
                  setCurrentDepartment,
                  companies,
                  currentCompany,
                  setCurrentCompany,
                  fetchJobsSuccess,
                  setCompanies,
                  // setDepartments,
                  setEmployees,
                  editingCompany,
                }) => {

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  })

  const history = useHistory()
  const { pathname } = useLocation()
  const { isLoggedIn, currentUser, logout } = useAuth()
  const translation = useTranslation()

  const [redirectToChangePassword, setRedirectToChangePassword] = useState(false)
  const allowUsers = useMemo(() => userHasPermission(currentUser, 'users'), [currentUser])
  const allowMms = useMemo(() => !currentUser.isRegularUser() && currentUser.allowUiMms(), [currentUser])
  const allowServerMms = useMemo(() => !currentUser.isRegularUser() && currentUser.allowMms(), [currentUser])
  const allowSystemTab = useMemo(() => currentUser.allowSystemTab(), [currentUser])
  const allowUiMap = useMemo(() => currentUser.allowUiMap(), [currentUser])
  const allowUiFleetView = useMemo(() => currentUser.allowUiFleetView(), [currentUser])
  const allowUiIntegrations = useMemo(() => currentUser.allowUiIntegrations(), [currentUser])
  const allowUiDevices = useMemo(() => currentUser.allowUiDevices(), [currentUser])
  const canManageTemplates = useMemo(() => currentUser && currentUser.canManageTemplates(), [currentUser])
  const isSuperUser = useMemo(() => currentUser.isSuperuser(), [currentUser])
  const showCompanySelector = useMemo(() => currentUser.isSuperuser() && !currentUser.isMaster(), [currentUser])
  const isNotOneJobPassword = useMemo(() => (currentUser && !currentUser.isOneJobPassword), [currentUser])
  const isNotOneUnitPassword = useMemo(() => (currentUser && !currentUser.isOneUnitPassword()), [currentUser])
  const hasAllowedUnits = useMemo(() => (currentUser && currentUser.hasAllowedUnits()), [currentUser])
  const isOneUnitPassword = useMemo(() => (currentUser && currentUser.isOneUnitPassword()), [currentUser])
  const [searchQuery, setSearchQuery] = useState('')

  const [isOpenNavMenu, setIsOpenNavMenu] = useState(false)
  const [isOpenSettingsMenu, setIsOpenSettingsMenu] = useState(false)
  const [isOpenChangeCompanyMenu, setIsOpenChangeCompanyMenu] = useState(false)
  const [isOpenChangeDepartmentMenu, setIsOpenChangeDepartmentMenu] = useState(false)
  const [isOpenMyCompanyMenu, setIsOpenMyCompanyMenu] = useState(false)
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)

  useEffect(() => {
    let locale
    if (navigator.languages !== undefined)
      locale = navigator.languages[0]
    else
      locale = navigator.language
    moment.locale(locale)
  }, [])

  useEffect(() => {
    async function fetchCompanies () {
      let res = await dmsApiService.getCompanies()
      setCompanies(res)
      if (res.length === 0)
        return
      const storedCompanyId = getStoredCompany()
      const storedCompanyModel = res.find(company => company.id === storedCompanyId)
      let defaultCompany
      if (storedCompanyModel) {
        defaultCompany = storedCompanyModel
      } else {
        if (currentUser.defaultCompanyId) {
          defaultCompany = res.find(company => company.id === currentUser.defaultCompanyId)
        }
        if (!defaultCompany) {
          defaultCompany = res[0]
        }
        setStoredCompany(defaultCompany.id)
      }
      setCurrentCompany(defaultCompany)
      // let jobsRes = await dmsApiService.getCompanyJobsShort(defaultCompany.id)
      // fetchJobsSuccess(jobsRes)
    }

    async function fetchJobs () {
      let jobsRes = await dmsApiService.getJobsShort()
      fetchJobsSuccess(jobsRes)
    }

    if (isSuperUser) {
      if (currentCompany)
        return
      fetchCompanies().then()
    } else {
      fetchJobs().then()
    }

  }, [currentUser, isSuperUser, fetchJobsSuccess, setCurrentCompany, setCompanies, currentCompany])

  useEffect(() => {
    async function fetchJobs () {
      let jobsRes = await dmsApiService.getCompanyJobsShort(currentCompany.id)
      fetchJobsSuccess(jobsRes)
    }

    if (currentCompany && isSuperUser)
      fetchJobs().then()
  }, [currentCompany, fetchJobsSuccess, isSuperUser])

  const toggleDrawer = (side, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setState({ ...state, [side]: open })
  }
  const toggleDrawer2 = (side, open) => {
    setState({ ...state, [side]: open })
  }

  const filteredCompanies = useMemo(() => {
    if (!companies || !searchQuery) return companies
    return companies.filter(company => 
      company.name.toLowerCase().includes(searchQuery.toLowerCase())
    )
  }, [companies, searchQuery])

  const { packageName } = useFooterSubscriptionPackage()
  const mobileSuiteLine = useMemo(
    () => (packageName ? `${packageName} • ${appName}` : appName),
    [packageName],
  )

  const [anchorMobileCompanyMenuEl, setAnchorMobileCompanyMenuEl] = useState(null)
  const handleMobileCompanyMenuOpen = (event) => {
    event.stopPropagation()
    setAnchorMobileCompanyMenuEl(event.currentTarget)
  }
  const handleMobileCompanyMenuClose = () => setAnchorMobileCompanyMenuEl(null)

  useEffect(() => {
    if (!state.left) {
      setAnchorMobileCompanyMenuEl(null)
    }
  }, [state.left])

  const closeMobileMenu = () => toggleDrawer2('left', false)

  const goTo = path => {
    closeMobileMenu()
    history.push(path)
  }

  const isActivePath = path => (path === '/' ? pathname === '/' : pathname.startsWith(path))

  const mmsPaths = ['/departments', '/employees', '/parts', '/equipment', '/catalog', '/unassigned-components', '/activities', '/reports']

  const renderMobileMmsSection = () => {
    if (allowServerMms) {
      return (
        <SlideMenuSection
          icon={DomainOutlinedIcon}
          group="options"
          label={translation.headerMmsLabel}
          active={mmsPaths.some(isActivePath)}
          expanded={isOpenNavMenu}
          onClick={() => setIsOpenNavMenu(!isOpenNavMenu)}
        >
          <SlideMenuSubItem
            label={translation.siderMyCompanyLabel}
            expanded={isOpenMyCompanyMenu}
            onClick={() => setIsOpenMyCompanyMenu(!isOpenMyCompanyMenu)}
          >
            <SlideMenuSubItem label={translation.myCompanyDepartmentsLabel} active={isActivePath('/departments')} onClick={() => goTo('/departments')}/>
            <SlideMenuSubItem label={translation.myCompanyEmployeesLabel} active={isActivePath('/employees')} onClick={() => goTo('/employees')}/>
            <SlideMenuSubItem label={translation.equipmentPagePartsLabel} active={isActivePath('/parts')} onClick={() => goTo('/parts')}/>
          </SlideMenuSubItem>
          <SlideMenuSubItem
            label={translation.popoverChangeDepartmentLabel}
            disabled={!departments || departments.length === 0}
            expanded={isOpenChangeDepartmentMenu}
            onClick={() => setIsOpenChangeDepartmentMenu(!isOpenChangeDepartmentMenu)}
          >
            {departments && departments.map(department => (
              <SlideMenuSubItem
                key={department.id}
                label={department.name}
                onClick={() => {
                  closeMobileMenu()
                  setCurrentDepartment(department)
                  setStoredDepartment(department.id)
                }}
              />
            ))}
          </SlideMenuSubItem>
          <SlideMenuSubItem label={translation.siderEquipmentLabel} active={isActivePath('/equipment')} onClick={() => goTo('/equipment')}/>
          <SlideMenuSubItem label={translation.siderUnassignedComponentsLabel} active={isActivePath('/unassigned-components')} onClick={() => goTo('/unassigned-components')}/>
          <SlideMenuSubItem label={translation.siderActivitiesLabel} active={isActivePath('/activities')} onClick={() => goTo('/activities')}/>
          <SlideMenuSubItem label={translation.siderScheduledReportsLabel} active={isActivePath('/reports')} onClick={() => goTo('/reports')}/>
        </SlideMenuSection>
      )
    }

    if (allowMms) {
      return (
        <SlideMenuSection
          icon={DomainOutlinedIcon}
          group="options"
          label={translation.headerMmsLabel}
          onClick={() => AlertToastr.showErrorAlert(translation.mmsAccessError)}
        />
      )
    }

    return null
  }

  const settingsLinks = [
    { path: '/settings/job-planner', label: translation.settingsJobPlannerLabel },
    { path: '/settings/users', label: translation.settingsTablesUsersLabel },
    { path: '/settings/one-job-password', label: translation.settingsTablesOneJobPasswordsLabel },
    { path: '/settings/db-management', label: translation.settingsDbManagementLabel, id: 'settingsDbManagementTab' },
    canManageTemplates && { path: '/settings/templates-management', label: translation.settingsTemplatesManagementLabel, id: 'settingsTemplatesManagementTab' },
    allowUiIntegrations && { path: '/settings/integrations', label: translation.settingsIntegrationsLabel, id: 'settingsIntegrationsTab' },
    allowUiDevices && { path: '/settings/devices', label: translation.settingsDevicesLabel, id: 'settingsDevicesTab' },
    { path: '/settings/job-configuration', label: translation.settingsJobConfigurationLabel, id: 'settingsJobConfigurationTab' },
    { path: '/settings/unit-settings', label: translation.settingsUnitSettingsLabel, id: 'settingsUnitSettingsTab' },
  ].filter(Boolean)

  const renderMobileMenuTop = () => (
    <>
      {currentCompany && (
        <div className="slideMenuCompany">
          <span className="slideMenuCompanyLogo">
            {editingCompany?.image
              ? <img src={`data:image/jpeg;base64,${editingCompany.image}`} alt="" />
              : <MyIcons icon="companyIcon" />
            }
          </span>
          <div className="slideMenuCompanyText">
            <span className="slideMenuCompanyName">
              {currentCompany?.name || translation.siderMyCompanyLabel}
            </span>
            {editingCompany?.timezone != null && editingCompany?.timezone !== '' && (
              <span className="slideMenuCompanyMeta">
                {translation.timezoneLabel}: {editingCompany.timezone}
              </span>
            )}
          </div>
          {editingCompany && (
            <>
              <IconButton className="slideMenuCompanySettings" onClick={handleMobileCompanyMenuOpen} aria-label="Menu">
                <MyIcons icon="settingsIcon" />
              </IconButton>
              <Popover
                open={Boolean(anchorMobileCompanyMenuEl)}
                anchorEl={anchorMobileCompanyMenuEl}
                onClose={handleMobileCompanyMenuClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <MenuItem
                  onClick={() => {
                    handleMobileCompanyMenuClose()
                    EventEmitter.emit('OpenSaveCompanyModal')
                  }}
                >
                  <MyIcons icon="createIcon" className="asideNavPopoverIcon" style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                  {translation.sideMenuEditCompanyLabel}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleMobileCompanyMenuClose()
                    EventEmitter.emit('ChangeCompanyLogo')
                  }}
                >
                  <MyIcons icon="photoCamera" className="asideNavPopoverIcon" style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                  {translation.sideMenuEditLogoLabel}
                </MenuItem>
              </Popover>
            </>
          )}
        </div>
      )}
      {companies && companies.length > 0 && currentCompany && (
        <div className="slideMenuCompanySelect changeCompanyHeader">
          <Autocomplete
            options={filteredCompanies || companies || []}
            getOptionLabel={(option) => option.name}
            value={currentCompany}
            onChange={(event, newValue) => {
              if (newValue) {
                setStoredCompany(newValue.id)
                setCurrentCompany(newValue)
                EventEmitter.emit('CompanyChanged', newValue)
                clearDashboard()
                setDepartments(null)
                setEmployees(null)
                window.location.reload()
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                margin="none"
                label={translation.headerCompanyLabel}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            )}
            renderOption={(option) => (
              <MenuItem
                value={option}
                className="filterMenuItem"
                style={{ padding: '0px 0px' }}
              >
                {option.name}
              </MenuItem>
            )}
          />
        </div>
      )}
    </>
  )

  const renderMobileMenuFooter = () => (
    <>
      {currentUser && !currentUser.isOneJobPassword && (
        <SlideMenuSection
          icon={VpnKeyOutlinedIcon}
          group="neutral"
          label={translation.headerMenuChangePasswordLabel}
          onClick={() => setRedirectToChangePassword(true)}
        />
      )}
      <SlideMenuSection
        icon={ExitToAppOutlinedIcon}
        group="danger"
        label={translation.headerMenuSignOutLabel}
        onClick={() => {
          closeMobileMenu()
          handleSignOut()
        }}
      />
      <div className="slideMenuCopyright">{mobileSuiteLine}</div>
    </>
  )

  // mobile main menu, the same look as the page Actions menu
  const renderMobileMenu = () => (
    <SlideMenu
      open={state.left}
      onClose={closeMobileMenu}
      title={translation.mobileMenuTitle}
      top={renderMobileMenuTop()}
      footer={renderMobileMenuFooter()}
    >
      {allowUiFleetView && (
        <SlideMenuSection
          icon={AssessmentOutlinedIcon}
          label={translation.headerFleetViewLabel}
          active={isActivePath('/fleet-view')}
          onClick={() => goTo('/fleet-view')}
        />
      )}
      {!isOneUnitPassword && (
        <SlideMenuSection
          icon={WorkOutlineIcon}
          label={translation.headerDmsCloudLabel}
          active={isActivePath('/')}
          onClick={() => goTo('/')}
        />
      )}
      {(isNotOneJobPassword || isOneUnitPassword) && (
        <SlideMenuSection
          icon={BlurLinearOutlinedIcon}
          label={translation.headerUnitsLabel}
          active={isActivePath('/units')}
          onClick={() => goTo('/units')}
        />
      )}
      {(isNotOneJobPassword || isNotOneUnitPassword) && (
        <SlideMenuSection
          icon={MyLocationOutlinedIcon}
          label={translation.headerLocationsLabel}
          active={isActivePath('/locations')}
          onClick={() => goTo('/locations')}
        />
      )}
      {allowUiMap && (
        <SlideMenuSection
          icon={MapOutlinedIcon}
          label="Map"
          active={isActivePath('/map')}
          onClick={() => goTo('/map')}
        />
      )}
      {renderMobileMmsSection()}
      {allowUsers && (
        <SlideMenuSection
          icon={SettingsOutlinedIcon}
          group="options"
          label={translation.headerSettings}
          active={isActivePath('/settings')}
          expanded={isOpenSettingsMenu}
          onClick={() => setIsOpenSettingsMenu(!isOpenSettingsMenu)}
        >
          {settingsLinks.map(link => (
            <SlideMenuSubItem
              key={link.path}
              id={link.id}
              label={link.label}
              active={isActivePath(link.path)}
              onClick={() => goTo(link.path)}
            />
          ))}
        </SlideMenuSection>
      )}
      {allowSystemTab && (
        <SlideMenuSection
          icon={StorageOutlinedIcon}
          group="options"
          label={translation.settingsDataUsageLabel}
          active={isActivePath('/companies')}
          onClick={() => goTo('/companies')}
        />
      )}
    </SlideMenu>
  )

  const handleSignOut = () => {
    setIsOpenDeleteModal(true)
  }

  const handleDeleteModalConfirm = () => {
    clearDashboard()
    logout()
  }

  const [userInfoMenuAchorEl, onUserInfoMenuAnchorElChange] = useState(null)
  const closeUserInfoMenu = () => {
    onUserInfoMenuAnchorElChange(null)
  }

  if (redirectToChangePassword)
    return <Redirect to="/change-password"/>

  const renderMmsLink = () => {

    if (allowServerMms) {
      return (
        <li>
          <NavLink
            isActive={(match, location) =>
              location.pathname === '/departments' ||
              location.pathname === '/employees' ||
              location.pathname === '/parts' ||
              location.pathname === '/equipment' ||
              location.pathname === '/catalog' ||
              location.pathname === '/activities' ||
              location.pathname === '/reports'

            }
            to={departments && departments.length > 0 ? '/equipment' : '/departments'}
            id="mainHeaderMmsBtn"
            exact activeClassName="active">
            {translation.headerMmsLabel}
          </NavLink>
        </li>
      )
    }

    if (allowMms) {
      return (
        <li>
          <NavLink
            onClick={e => {
              e.preventDefault()
              AlertToastr.showErrorAlert(translation.mmsAccessError)
            }}
            to={departments && departments.length > 0 ? '/equipment' : '/departments'}
            exact activeClassName="active">
            {translation.headerMmsLabel}
          </NavLink>
        </li>
      )
    }

    return null
  }

  return (
    <header className="mainHeader">
      <div className="wrapper align-center">
        <div className="mainMenuHolder">
          <Link to="/" className="logo"/>
        </div>
        {/*<DbSizeInfo/>*/}
        <Box display="flex">
          <ul className="mainMenu">
            {allowUiFleetView && (
              <li>
                <NavLink
                  to="/fleet-view"
                  exact
                  activeClassName="active"
                  id="headerFleetViewBtn"
                >
                  {translation.headerFleetViewLabel}
                </NavLink>
              </li>
            )}
            {
              !isOneUnitPassword && (
                <li>
                  <NavLink
                    to="/"
                    exact
                    activeClassName="active"
                    id="headerJobsBtn"
                  >
                    {translation.headerDmsCloudLabel}
                  </NavLink>
                </li>
              )
            }
            {
              (isNotOneJobPassword || isOneUnitPassword) && (
                <li>
                  <NavLink
                    to="/units"
                    exact
                    activeClassName="active"
                    id="headerUnitsBtn"
                  >
                    {translation.headerUnitsLabel}
                  </NavLink>
                </li>
              )
            }
            {
              (isNotOneJobPassword && isNotOneUnitPassword) && (
                <li>
                  <NavLink
                    to="/locations"
                    exact
                    activeClassName="active"
                    id="headerLocationsBtn"
                  >
                    {translation.headerLocationsLabel}
                  </NavLink>
                </li>
              )
            }
            {allowUiMap && (
            <li>
              <NavLink
                to="/map"
                exact
                activeClassName="active"
              >
                Map
              </NavLink>
            </li>
            )}

            {renderMmsLink()}
            {allowUsers &&
              <li>
                <NavLink
                  to="/settings"
                  activeClassName="active"
                  id="headerSettingsBtn"
                >
                  {translation.headerSettings}
                </NavLink>
              </li>}
            {allowSystemTab &&
              <li>
                <NavLink
                  to="/companies"
                  activeClassName="active"
                >
                  {translation.settingsDataUsageLabel}
                </NavLink>
              </li>}
          </ul>
          {isLoggedIn && (
            <div className="userInfoHolder">
              {showCompanySelector && (
                <div className="changeCompanyHeader">
                {currentCompany && (
                <Autocomplete
                  options={filteredCompanies || companies || []}
                  getOptionLabel={(option) => option.name}
                  value={currentCompany}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setStoredCompany(newValue.id)
                      setCurrentCompany(newValue)
                      EventEmitter.emit('CompanyChanged', newValue)
                      clearDashboard()
                      setDepartments(null)
                      setEmployees(null)
                      window.location.reload()
                    }
                  }}
                  renderInput={(params) => (
                    <Tooltip title={currentCompany?.name || ''} arrow>
                      <TextField
                        {...params}
                        variant="outlined"
                        margin="none"
                        label={translation.headerCompanyLabel}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </Tooltip>
                  )}
                  renderOption={(option) => (
                    <MenuItem
                      value={option}
                      className="filterMenuItem"
                      style={{ padding: '0px 0px', whiteSpace: 'wrap' }}
                    >
                      {option.name}
                    </MenuItem>
                  )}
                />
              )}
              </div>
              )}
              <Button className="dropDownBtn desktop"
                      onClick={(e) => onUserInfoMenuAnchorElChange(e.target)}
                // onClick={() => history.push('/company-settings')}
                      startIcon={<UserIcon name={currentUser?.name}/>}>
                <div className="name">{currentUser && currentUser.name}</div>
              </Button>
              <IconButton className="dropDownBtn mobile"
                          onClick={(e) => onUserInfoMenuAnchorElChange(e.target)}>
                <UserIcon name={currentUser?.name}/>
              </IconButton>
              <Popover
                anchorEl={userInfoMenuAchorEl}
                keepMounted
                open={Boolean(userInfoMenuAchorEl)}
                onClose={closeUserInfoMenu}
                disableScrollLock={true}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
              >
                {currentUser && !currentUser.isOneJobPassword &&
                  <MenuItem onClick={() => setRedirectToChangePassword(true)}
                            className="filterMenuItem">{translation.headerMenuChangePasswordLabel}</MenuItem>
                }
                <MenuItem href="#/action-2" onClick={handleSignOut}
                          className="filterMenuItem">{translation.headerMenuSignOutLabel}</MenuItem>
              </Popover>
            </div>
          )}
        </Box>

        <div className={'mobileDrawer'}>
          <IconButton onClick={toggleDrawer('left', true)}>
            <MenuIcon/>
          </IconButton>
          {renderMobileMenu()}
        </div>
      </div>
      <DeleteItemModal
        isOpen={isOpenDeleteModal}
        isOpenManager={setIsOpenDeleteModal}
        message={translation.headerMenuSignOutMessageLabel}
        onDeleteModalClose={handleDeleteModalConfirm}
        confirmButtonLabel={translation.headerMenuSignOutBtnLabel}
      />

    </header>
  )
}

const mapDispatchToProps = {
  clearDashboard,
  setCurrentCompany,
  setCurrentDepartment,
  fetchJobsSuccess,
  setCompanies,
  setDepartments,
  setEmployees,
}

const mapStateToProps = ({ mms, dashboard }) => ({
  departments: mms.departments,
  companies: dashboard.companies,
  currentCompany: dashboard.currentCompany,
  editingCompany: mms.editingCompany,
})

export default connect(mapStateToProps, mapDispatchToProps)(Header)
